import { Children, cloneElement, isValidElement, type ReactElement, type ReactNode } from 'react';
import { Card } from '@shared/ui/containers/Card';
import { cn } from '@shared/lib/cn';

/**
 * iOS-grouped list container. Rounds the outer corners, paints hairline
 * dividers between rows, and clips overflow so list items render flush
 * with the group's edges.
 */
interface ListGroupProps {
  children: ReactNode;
  className?: string;
}

export function ListGroup({ children, className }: ListGroupProps): JSX.Element {
  const items = Children.toArray(children).filter(isValidElement) as ReactElement[];

  return (
    <Card
      noGrain
      className={cn(
        'overflow-hidden p-0',
        className,
      )}
    >
      {items.map((child, index) => (
        <div key={child.key ?? index}>
          {index > 0 ? <div className="hairline-t mx-4" aria-hidden /> : null}
          {cloneElement(child)}
        </div>
      ))}
    </Card>
  );
}
